/** @jsx jsx */
import { memo } from 'react';
import { css, jsx } from '@emotion/react';
import DateComponent from './date';
var daysGridStyles = css({
  display: 'grid',
  gridTemplateColumns: 'repeat(7, 1fr)',
  border: 0
});
var WeekDays = /*#__PURE__*/memo(function WeekDays(_ref) {
  var weeks = _ref.weeks,
      handleClickDay = _ref.handleClickDay,
      mode = _ref.mode,
      testId = _ref.testId;
  return jsx("div", {
    role: "grid",
    "data-testid": testId && "".concat(testId, "--month")
  }, weeks.map(function (week) {
    return jsx("div", {
      role: "row",
      key: week.id,
      css: daysGridStyles
    }, week.values.map(function (weekDay) {
      return jsx(DateComponent, {
        key: weekDay.id,
        isDisabled: weekDay.isDisabled,
        isFocused: weekDay.isFocused,
        isToday: weekDay.isToday,
        month: weekDay.month,
        onClick: handleClickDay,
        isPreviouslySelected: weekDay.isPreviouslySelected,
        isSelected: weekDay.isSelected,
        isSibling: weekDay.isSiblingMonth,
        year: weekDay.year,
        mode: mode,
        testId: testId
      }, weekDay.day);
    }));
  }));
});
WeekDays.displayName = 'WeekDays'; // eslint-disable-next-line @repo/internal/react/require-jsdoc

export default WeekDays;